(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noaic-article-reviewed"] && !Shopify.designMode) return;
  try {
    
function noaicJournalTables(root) {
  root.querySelectorAll('.noaic-journal-article__body table').forEach(table => {
    const region = table.parentElement;
    if (region && region.tagName === 'DIV') {
      region.setAttribute('tabindex', '0');
      region.setAttribute('role', 'region');
      region.setAttribute('aria-label', table.closest('.noaic-journal-article__body').dataset.tableLabel);
    }
  });
}
noaicJournalTables(document);
document.addEventListener('shopify:section:load', event => noaicJournalTables(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noaic-header-reviewed"]) return;
  try {
    
if (!window.noaicMenuEvents) {
  window.noaicMenuEvents = true;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const header = event.target.closest('.noaic-header');
    if (!header) return;
    const open = [...header.querySelectorAll('details[open]')].reverse()[0];
    if (open) { open.open = false; open.querySelector('summary').focus(); }
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.noaic-header details[open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noaic-video-stories-reviewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noaic-video-story')) {
    customElements.define('noaic-video-story', class extends HTMLElement {
      constructor() {
        super();
        this.onPlay = this.play.bind(this);
      }

      connectedCallback() {
        this.trigger = this.querySelector('.noaic-videos__trigger');
        this.trigger?.addEventListener('click', this.onPlay);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onPlay);
      }

      reset() {
        this.querySelector('iframe')?.remove();
        if (this.trigger) this.trigger.hidden = false;
      }

      play() {
        if (this.querySelector('iframe')) return;
        let source;
        try {
          const url = new URL(this.dataset.videoUrl);
          const host = url.hostname.replace(/^www\./, '');
          const parts = url.pathname.split('/').filter(Boolean);
          let id;
          if (host === 'youtu.be') {
            id = parts[0];
          } else if (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'].includes(host)) {
            id = url.searchParams.get('v') || (['embed', 'shorts', 'live'].includes(parts[0]) ? parts[1] : '');
          }
          if (id && /^[a-zA-Z0-9_-]{11}$/.test(id)) {
            source = new URL('https://www.youtube-nocookie.com/embed/' + id);
            source.searchParams.set('rel', '0');
            source.searchParams.set('mute', '1');
            source.searchParams.set('playsinline', '1');
          } else if (['vimeo.com', 'player.vimeo.com'].includes(host)) {
            const videoId = parts[0] === 'video' ? parts[1] : parts[0];
            if (!/^\d+$/.test(videoId || '')) return;
            source = new URL('https://player.vimeo.com/video/' + videoId);
            const hash = url.searchParams.get('h') || (parts[0] !== 'video' ? parts[1] : '');
            if (hash) source.searchParams.set('h', hash);
            source.searchParams.set('playsinline', '1');
          } else {
            return;
          }
        } catch {
          return;
        }
        source.searchParams.set('autoplay', '1');
        document.querySelectorAll('noaic-video-story').forEach(card => card.reset());
        const player = document.createElement('iframe');
        player.className = 'noaic-videos__player';
        player.title = this.trigger.getAttribute('aria-label');
        player.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        player.allowFullscreen = true;
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        player.src = source.toString();
        this.appendChild(player);
        this.trigger.hidden = true;
        player.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
